import Tracker from "../prop-trackers/tracker.js";
import DictTracker from "../prop-trackers/dict-tracker.js";
import TrackerGroup from "../prop-trackers/tracker-group.js";
import { ForEach, ValueTracker } from "./for-each.js";
import Zipper from "./zipper.js";

class Groups extends Tracker {
    constructor(rootTracker, keys, makeElementKeyGen) {
        super();

        this._rootTracker = rootTracker;
        this._makeElementKeyGen = makeElementKeyGen;

        this._elementsKeyForEach = new DictTracker();
        this._keyGenKey = new WeakMap();
        this._keyForEach = new ForEach(this._elementsKeyForEach, (key) => {
            const mapper = makeElementKeyGen(key);
            this._keyGenKey.set(mapper, key);
            return mapper;
        });

        this._elementsTracker = new DictTracker();
        this._keysTracker = new DictTracker();

        this._elementKeyZipper = new Zipper();
        this._elementKeyZipper.setSource("element", this._elementsTracker);
        this._elementKeyZipper.setSource("key", this._keysTracker);

        this._groupTracker = new TrackerGroup();
        this._groupTrackers = new Map();
        for (const key of keys) {
            const tracker = new DictTracker(key);
            this._groupTrackers.set(key, tracker);
            this._groupTracker.add(tracker);
        }

        const needsUpdate = () => this.protected_needsUpdate();
        this._rootTracker.listenNeedsUpdate(needsUpdate);
        this._keyForEach.listenNeedsUpdate(needsUpdate);
        this._elementKeyZipper.listenNeedsUpdate(needsUpdate);
    }

    protected_startUpdate() {
        this._rootTracker.update(({ props }) => {
            for (const { key, newExists, newValue } of props.iterateModified()) {
                if (newExists) {
                    this._elementsTracker.setValue(key, newValue);
                    this._elementsKeyForEach.setValue(key, newValue);
                } else {
                    this._elementsTracker.deleteValue(key);
                    this._elementsKeyForEach.deleteValue(key);
                }
            }
        });

        this._keyForEach.update(({ trackers }) => {
            for (const keyGen of trackers) {
                const key = this._keyGenKey.get(keyGen);

                keyGen.update(({ prop: { newExists, newValue } }) => {
                    if (newExists) {
                        this._keysTracker.setValue(key, newValue);
                    } else {
                        this._keysTracker.deleteValue(key);
                    }
                });
            }
        });

        this._elementKeyZipper.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ props, userdata: key }) => {
                    const { oldExists: oldGrpExists, oldValue: oldGrp, newExists: newGrpExists, newValue: newGrp } = props.get("key");
                    const { oldExists: oldElmExists, newExists: newElmExists, newValue: newElm } = props.get("element");

                    if (oldGrpExists && oldElmExists) {
                        this._groupTrackers.get(oldGrp).deleteValue(key);
                    }

                    if (newGrpExists && newElmExists) {
                        this._groupTrackers.get(newGrp).setValue(key, newElm);
                    }
                });
            }
        });

        return this._groupTracker.protected_startUpdate();
    }

    protected_finishUpdate() {
        this._groupTracker.protected_finishUpdate();
    }
}

export default Groups;
